import { useState } from 'react';
import { Menu, Card, Space } from 'antd';
import './AccountPage.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from './AccountPage.lang.json';
import ChangePersonalInfo from '../components/AccountSettings/ChangePersonalInfo';
import ChangeBeneficiariesInfo from '../components/AccountSettings/ChangeBeneficiariesInfo';
import InvestmentAccountDetails from '../components/AccountSettings/InvestmentAccountDetails';
import Statements from '../components/Statements';
import UserDashboardActionItems from '../components/UserDashboardActionItems';
import TransfersManager from '../components/TransfersManager';
import AccountBalance from '../components/AccountBalance';
import EmployerOnboardedPayrollStatus from '../components/EmployerOnboardedPayrollStatus';
import ManageTrustedContact from '../components/AccountSettings/ManageTrustedContact';
import { useAuth } from '../utils/AuthContext';
import ManagePayrollElections from '../components/AccountSettings/ManagePayrollElections';
import { useRefreshingAsync } from '../components/common/commonHooks';

const AccountPage = () => {
  const { lang } = useLanguage(translations);
  const [selectedKey, setSelectedKey] = useState(null);
  const { api, userEmployments } = useAuth();
  const investmentAccounts = useRefreshingAsync(api.getInvestmentAccounts);
  const items = [
    {
      key: 'userHome',
      label: lang('userHome'),
    },
    {
      key: 'accountSettings',
      label: lang('accountSettings'),
      children: [
        {
          key: 'changePersonalInfo',
          label: lang('changePersonalInfo'),
        },
        {
          key: 'manageBeneficiaries',
          label: lang('manageBeneficiaries'),
        },
        {
          key: 'investmentAccountDetails',
          label: lang('investmentAccountDetails'),
        },
        {
          key: 'manageTrustedContact',
          label: lang('manageTrustedContact'),
        },
      ],
    },
    {
      key: 'manageTransfers',
      label: lang('manageTransfers'),
    },
    ...(userEmployments?.length > 0
      ? [
          {
            key: 'managePayrollContributions',
            label: lang('managePayrollContributions'),
          },
        ]
      : []),
    {
      key: 'statements',
      label: lang('statements'),
    },
    {
      key: 'contactSupport',
      label: lang('contactSupport'),
    },
    {
      type: 'divider',
    },
    {
      key: 'recommendCrecer',
      label: lang('recommendCrecer'),
    },
  ];
  const onMenuClick = (e) => {
    setSelectedKey(e.key);
  };

  const displaySelectedItem = () => {
    switch (selectedKey) {
      case 'changePersonalInfo':
        return <ChangePersonalInfo />;
      case 'manageBeneficiaries':
        return <ChangeBeneficiariesInfo />;
      case 'manageTrustedContact':
        return <ManageTrustedContact />;
      case 'investmentAccountDetails':
        return <InvestmentAccountDetails />;
      case 'manageTransfers':
        return <TransfersManager />;
      case 'managePayrollContributions':
        return <ManagePayrollElections />;
      case 'statements':
        return <Statements />;
      // case 'contactSupport':
      // return <ContactSupport />;
      // case 'recommendCrecer':
      // return <RecommendCrecer />;
      case 'userHome':
      default:
        return displayUserDashboard();
    }
  };

  const displayUserDashboard = () => {
    return (
      <Space direction="vertical">
        {(userEmployments ?? []).map((employment, i) => (
          <EmployerOnboardedPayrollStatus key={i} employment={employment} />
        ))}

        {investmentAccounts &&
          investmentAccounts.map((account) => (
            <AccountBalance key={account.investmentAccountId} investmentAccounts={account} />
          ))}

        <Card title={lang('actionItemsTitle')}>
          {investmentAccounts &&
            investmentAccounts.map((account) => (
              <UserDashboardActionItems
                key={account.investmentAccountId}
                investmentAccountId={account.investmentAccountId}
              />
            ))}
        </Card>
      </Space>
    );
  };

  return (
    <main className="main-container">
      <Menu onClick={onMenuClick} className="sidebar-menu" mode="inline" items={items} selectedKeys={[selectedKey]} />
      <div className="content-area">{displaySelectedItem()}</div>
    </main>
  );
};

export default AccountPage;
